import Icon from '../components/Icon.vue'

Icon.register({
  'align-center': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M432 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416zM432 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416zM108.1 96c-6.7 0-12.1-5.4-12.1-12.1v-39.8c0-6.7 5.4-12.1 12.1-12.1h0 231.8c6.7 0 12.1 5.4 12.1 12.1v39.8 0c0 6.7-5.4 12.1-12.1 12.1v0h-231.8zM339.9 352h-231.8c-6.7 0-12.1-5.4-12.1-12.1v-39.8c0-6.7 5.4-12.1 12.1-12.1h0 231.8c6.7 0 12.1 5.4 12.1 12.1v39.8 0c0 6.7-5.4 12.1-12.1 12.1v0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/align-center.js
// module id = 591
// module chunks = 0